__webpack_require__.p = "https://static.age.awaze.com/search-mfe/daaa0c7/_next/";